import { createApp, h, ref } from 'vue';
import Message from '@/components/common/CustomMessage.vue';

let seed = 1;
const instances: any = ref([]);

const message: any = (options: any) => {
  if (typeof options === 'string') {
    options = {
      message: options,
    };
  }

  const id: any = `message_${seed++}`;
  const userOnClose: any = options.onClose;
  const container: any = document.createElement('div');

  options.onClose = () => {
    close(id, userOnClose);
  };

  const app = createApp({
    setup() {
      return () =>
        h(Message, {
          ...options,
          id,
        });
    },
  });

  const instance: any = app.mount(container);
  document.body.appendChild(container.firstElementChild);

  // 计算垂直偏移量
  let verticalOffset = options.offset || 20;
  instances.value.forEach((item: any) => {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  instance.offset = verticalOffset;

  instances.value.push(instance);
  return {
    close: () => instance.close(),
  };
};

const close = (id: any, userOnClose: any) => {
  const index = instances.value.findIndex((item: any) => item.id === id);
  if (index === -1) return;

  const instance: any = instances.value[index];
  if (typeof userOnClose === 'function') {
    userOnClose(instance);
  }

  const removedHeight = instance.$el.offsetHeight;
  instances.value.splice(index, 1);

  // 调整其他消息位置
  for (let i = index; i < instances.value.length; i++) {
    instances.value[i].offset =
      parseInt(instances.value[i].offset) - removedHeight - 16;
  }
};

const closeAll = () => {
  instances.value.forEach((instance: any) => {
    instance.close();
  });
};

// 添加不同类型的方法
['success', 'warning', 'info', 'error'].forEach((type) => {
  message[type] = (options: any) => {
    if (typeof options === 'string') {
      return message({
        message: options,
        type,
      });
    }
    return message({
      ...options,
      type,
    });
  };
});

message.closeAll = closeAll;

export default message;
